import React, { useState, useEffect } from "react";
import { Link, useHistory } from "react-router-dom";
import axios from "axios";
import DatePicker from "react-datepicker";
import { useSelector } from "react-redux";

export default function ReportApplicationsV2() {
    const { current_staff } = useSelector((state) => state.auth);
    const { settings } = useSelector((state) => state.settings);
    const history = useHistory();
    const [allowClick, setAllowClick] = useState(true);

    useEffect(async () => {
        if (history.action == "POP") {
            if (allowClick === true) {
                axios({
                    method: "get",
                    url: `${process.env.REACT_APP_API_URL}channels`,
                });
                axios({
                    method: "get",
                    url: `${process.env.REACT_APP_API_URL}tagsList`,
                });
                axios({
                    method: "get",
                    url: `${process.env.REACT_APP_API_URL}collectionList`,
                });
                axios({
                    method: "get",
                    url: `${process.env.REACT_APP_API_URL}mentionList/${current_staff.id}`,
                });

                if (settings && settings.brokers === 1) {
                    axios({
                        method: "get",
                        url: `${process.env.REACT_APP_API_URL}brokers`,
                    });
                }

                setAllowClick(false);
            }
        }
    }, []);

    const [reportData, setReportData] = useState(null);
    const [loading, setLoading] = useState(false);
    const [fromDate, setFromDate] = useState(null);
    const [toDate, setToDate] = useState(null);
    const [showModal, setShowModal] = useState(false);
    const [modalBookings, setModalBookings] = useState([]);
    const [modalTitle, setModalTitle] = useState("");
    const [modalLoading, setModalLoading] = useState(false);
    const [currentPropertyId, setCurrentPropertyId] = useState(null);
    const [currentFolder, setCurrentFolder] = useState(null);

    async function getReportData() {
        if (!fromDate || !toDate) {
            alert("Please select both From Date and To Date");
            return;
        }

        setLoading(true);
        axios({
            method: "post",
            url: `${process.env.REACT_APP_API_URL}reports/applications_v2`,
            data: { fromDate: fromDate, toDate: toDate },
        })
            .then((response) => {
                setReportData(response.data);
                setLoading(false);
            })
            .catch((error) => {
                alert("Failed to load Applications Report V2");
                setLoading(false);
            });
    }

    async function exportFullReport() {
        if (!fromDate || !toDate) {
            alert("Please generate the report first");
            return;
        }

        const token = localStorage.getItem('token');
        
        axios({
            method: 'post',
            url: `${process.env.REACT_APP_API_URL}reports/applications_v2_export`,
            data: { fromDate: fromDate, toDate: toDate },
            responseType: 'blob',
            headers: {
                'Authorization': `Bearer ${token}`
            }
        })
        .then((response) => {
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', 'applications_v2_report.xlsx');
            document.body.appendChild(link);
            link.click();
            link.remove();
        })
        .catch((error) => {
            alert("Failed to export report");
        });
    }

    async function openBookingsModal(propertyId, propertyName, folder, folderLabel) {
        setModalTitle(`${propertyName} - ${folderLabel}`);
        setCurrentPropertyId(propertyId);
        setCurrentFolder(folder);
        setShowModal(true);
        setModalLoading(true);

        axios({
            method: "post",
            url: `${process.env.REACT_APP_API_URL}reports/applications_v2_bookings`,
            data: {
                fromDate: fromDate,
                toDate: toDate,
                property_id: propertyId,
                folder: folder,
            },
        })
            .then((response) => {
                setModalBookings(response.data.bookings);
                setModalLoading(false);
            })
            .catch((error) => {
                alert("Failed to load bookings");
                setModalLoading(false);
            });
    }

    function exportModalBookings() {
        const token = localStorage.getItem('token');
        
        axios({
            method: 'post',
            url: `${process.env.REACT_APP_API_URL}reports/applications_v2_bookings_export`,
            data: { 
                fromDate: fromDate, 
                toDate: toDate,
                property_id: currentPropertyId,
                folder: currentFolder
            },
            responseType: 'blob',
            headers: {
                'Authorization': `Bearer ${token}`
            }
        })
        .then((response) => {
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', 'applications_v2_bookings.xlsx');
            document.body.appendChild(link);
            link.click();
            link.remove();
        })
        .catch((error) => {
            alert("Failed to export bookings");
        });
    }

    const calculateTotals = () => {
        if (!reportData || !reportData.properties) return null;

        const totals = reportData.properties.reduce(
            (acc, property) => {
                return {
                    total_applications: acc.total_applications + property.total_applications,
                    moved_to_documents: acc.moved_to_documents + property.moved_to_documents,
                    pending_documents: acc.pending_documents + (property.pending_documents || 0),
                    archived_pending_documents: acc.archived_pending_documents + (property.archived_pending_documents || 0),
                    moved_to_vetting: acc.moved_to_vetting + property.moved_to_vetting,
                    pending_vetting: acc.pending_vetting + (property.pending_vetting || 0),
                    archived_pending_vetting: acc.archived_pending_vetting + (property.archived_pending_vetting || 0),
                    moved_to_approved: acc.moved_to_approved + property.moved_to_approved,
                    declined_vetting: acc.declined_vetting + property.declined_vetting,
                    moved_to_lease_sent: acc.moved_to_lease_sent + property.moved_to_lease_sent,
                    pending_lease_sent: acc.pending_lease_sent + (property.pending_lease_sent || 0),
                    archived_pending_lease_sent: acc.archived_pending_lease_sent + (property.archived_pending_lease_sent || 0),
                    moved_to_lease_signed: acc.moved_to_lease_signed + property.moved_to_lease_signed,
                    pending_lease_signed: acc.pending_lease_signed + (property.pending_lease_signed || 0),
                    archived_pending_lease_signed: acc.archived_pending_lease_signed + (property.archived_pending_lease_signed || 0),
                    moved_to_move_in_booked: acc.moved_to_move_in_booked + property.moved_to_move_in_booked,
                    pending_move_in_booked: acc.pending_move_in_booked + (property.pending_move_in_booked || 0),
                    archived_pending_move_in_booked: acc.archived_pending_move_in_booked + (property.archived_pending_move_in_booked || 0),
                    moved_to_moved_in: acc.moved_to_moved_in + property.moved_to_moved_in,
                };
            },
            {
                total_applications: 0,
                moved_to_documents: 0,
                pending_documents: 0,
                archived_pending_documents: 0,
                moved_to_vetting: 0,
                pending_vetting: 0,
                archived_pending_vetting: 0,
                moved_to_approved: 0,
                declined_vetting: 0,
                moved_to_lease_sent: 0,
                pending_lease_sent: 0,
                archived_pending_lease_sent: 0,
                moved_to_lease_signed: 0,
                pending_lease_signed: 0,
                archived_pending_lease_signed: 0,
                moved_to_move_in_booked: 0,
                pending_move_in_booked: 0,
                archived_pending_move_in_booked: 0,
                moved_to_moved_in: 0,
            }
        );

        totals.conversion_rate =
            totals.total_applications > 0
                ? ((totals.moved_to_moved_in / totals.total_applications) * 100).toFixed(1)
                : 0;

        return totals;
    };

    const totals = calculateTotals();

    return (
        <>
            <div className="h-screen w-auto bg-gray-100 my-6 xl:my-0 xl:mx-4 rounded-3xl flex-1 p-5">
                <div className="flex justify-between items-center mb-5">
                    <h1 className="text-2xl font-bold">Applications Report V2 - Funnel Flow</h1>
                    <Link
                        to="/reports/applications"
                        className="text-sm text-blue-600 hover:text-blue-800 underline"
                    >
                        View V1 Report
                    </Link>
                </div>

                <p className="text-sm text-gray-600 mb-5">
                    This report tracks how many leads moved through each folder within the selected date range.
                    Uses Atlas-style counting methodology for accuracy.
                </p>

                <div className="my-5 flex items-end gap-4">
                    <div>
                        <label className="block text-sm font-medium text-gray-700">From Date</label>
                        <DatePicker
                            selected={fromDate}
                            onChange={(value) => {
                                setFromDate(value);
                                setReportData(null);
                            }}
                            className="z-20 block w-full font-light border border-gray-300 shadow-sm mt-1 py-2 pl-2 rounded-lg focus:outline-none focus:ring-primary focus:border-primary sm:text-sm transition ease-linear duration-10 hover:border-primary"
                            dateFormat={"d MMMM yyyy"}
                            peekNextMonth
                            showMonthDropdown
                            showYearDropdown
                            dropdownMode="select"
                        />
                    </div>

                    <div>
                        <label className="block text-sm font-medium text-gray-700">To Date</label>
                        <DatePicker
                            selected={toDate}
                            onChange={(value) => {
                                setToDate(value);
                                setReportData(null);
                            }}
                            className="z-20 block w-full font-light border border-gray-300 shadow-sm mt-1 py-2 pl-2 rounded-lg focus:outline-none focus:ring-primary focus:border-primary sm:text-sm transition ease-linear duration-10 hover:border-primary"
                            dateFormat={"d MMMM yyyy"}
                            peekNextMonth
                            showMonthDropdown
                            showYearDropdown
                            dropdownMode="select"
                        />
                    </div>

                    <button
                        className="justify-center w-48 relative flex text-white uppercase items-center px-4 py-2 rounded-lg text-sm focus:z-10 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary bg-primary hover:bg-primary_hover transition duration-150 ease-in-ease-out hover:-translate-y-0.5"
                        onClick={() => getReportData()}
                        disabled={loading}
                    >
                        {loading ? "Loading..." : "Generate Report"}
                    </button>

                    {reportData && reportData.properties && (
                        <button
                            className="justify-center w-48 relative flex text-white uppercase items-center px-4 py-2 rounded-lg text-sm focus:z-10 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-green-600 bg-green-600 hover:bg-green-700 transition duration-150 ease-in-ease-out hover:-translate-y-0.5"
                            onClick={() => exportFullReport()}
                        >
                            Export to Excel
                        </button>
                    )}
                </div>

                {reportData && reportData.properties && (
                    <div className="mt-8 overflow-x-auto">
                        <h2 className="text-lg font-semibold mb-4">
                            Funnel Flow: {new Date(reportData.fromDate).toLocaleDateString()} -{" "}
                            {new Date(reportData.toDate).toLocaleDateString()}
                        </h2>

                        <div className="flex items-center gap-4 mb-2 text-xs">
                            <span className="text-gray-500">Legend:</span>
                            <span className="inline-flex items-center gap-1">
                                <span className="inline-block w-4 h-4 rounded bg-amber-50 border border-amber-200 text-center text-[10px] font-bold text-amber-800 leading-4">P</span>
                                <span className="text-gray-600">= Pending (stuck at stage)</span>
                            </span>
                            <span className="inline-flex items-center gap-1">
                                <span className="inline-block w-4 h-4 rounded bg-gray-100 border border-gray-300 text-center text-[10px] font-bold text-gray-500 leading-4">A</span>
                                <span className="text-gray-600">= Archived (entered stage &amp; now archived)</span>
                            </span>
                            <span className="inline-flex items-center gap-1">
                                <span className="text-gray-600">→ = moved into stage</span>
                            </span>
                        </div>

                        <table className="min-w-full divide-y divide-gray-300 bg-white shadow-sm rounded-lg">
                            <thead className="bg-gray-50">
                                <tr className="border-b border-gray-200">
                                    <th colSpan={2} className="sticky left-0 bg-gray-50"></th>
                                    <th colSpan={3} className="px-1 pt-2 pb-0 text-center text-[10px] font-medium text-gray-400 bg-gray-50 border-l-2 border-gray-300">Docs</th>
                                    <th colSpan={5} className="px-1 pt-2 pb-0 text-center text-[10px] font-medium text-gray-400 bg-gray-50 border-l-2 border-gray-300">Vetting</th>
                                    <th colSpan={3} className="px-1 pt-2 pb-0 text-center text-[10px] font-medium text-gray-400 bg-gray-50 border-l-2 border-gray-300">Lease Sent</th>
                                    <th colSpan={3} className="px-1 pt-2 pb-0 text-center text-[10px] font-medium text-gray-400 bg-gray-50 border-l-2 border-gray-300">Lease Signed</th>
                                    <th colSpan={3} className="px-1 pt-2 pb-0 text-center text-[10px] font-medium text-gray-400 bg-gray-50 border-l-2 border-gray-300">Move In Booked</th>
                                    <th colSpan={2} className="px-1 pt-2 pb-0 text-center text-[10px] font-medium text-gray-400 bg-gray-50 border-l-2 border-gray-300"></th>
                                </tr>
                                <tr>
                                    <th className="px-3 py-2 text-left text-xs font-semibold text-gray-900 sticky left-0 bg-gray-50">
                                        Property
                                    </th>
                                    <th className="px-2 py-2 text-center text-xs font-semibold text-gray-900 cursor-help" title="Click cells to view bookings">
                                        Apps
                                    </th>
                                    <th className="px-2 py-2 text-center text-xs font-semibold text-gray-900 cursor-help border-l-2 border-gray-300" title="Click cells to view bookings">
                                        →
                                    </th>
                                    <th className="px-1 py-2 text-center text-xs font-semibold text-amber-800 bg-amber-50 cursor-help" title="Pending: entered stage but never moved further">
                                        P
                                    </th>
                                    <th className="px-1 py-2 text-center text-xs font-semibold text-gray-500 bg-gray-100 cursor-help" title="Archived: entered this stage and now archived">
                                        A
                                    </th>
                                    <th className="px-2 py-2 text-center text-xs font-semibold text-gray-900 cursor-help border-l-2 border-gray-300" title="Click cells to view bookings">
                                        →
                                    </th>
                                    <th className="px-1 py-2 text-center text-xs font-semibold text-amber-800 bg-amber-50 cursor-help" title="Pending: entered Vetting but not yet approved or declined">
                                        P
                                    </th>
                                    <th className="px-1 py-2 text-center text-xs font-semibold text-gray-500 bg-gray-100 cursor-help" title="Archived: entered Vetting and now archived">
                                        A
                                    </th>
                                    <th className="px-2 py-2 text-center text-xs font-semibold text-gray-900 cursor-help border-l-2 border-gray-300" title="Click cells to view bookings">
                                        → Appr
                                    </th>
                                    <th className="px-2 py-2 text-center text-xs font-semibold text-gray-900 bg-red-50 cursor-help" title="Click cells to view bookings">
                                        Decl
                                    </th>
                                    <th className="px-2 py-2 text-center text-xs font-semibold text-gray-900 cursor-help border-l-2 border-gray-300" title="Click cells to view bookings">
                                        →
                                    </th>
                                    <th className="px-1 py-2 text-center text-xs font-semibold text-amber-800 bg-amber-50 cursor-help" title="Pending: lease sent but not yet signed">
                                        P
                                    </th>
                                    <th className="px-1 py-2 text-center text-xs font-semibold text-gray-500 bg-gray-100 cursor-help" title="Archived: entered Lease Sent and now archived">
                                        A
                                    </th>
                                    <th className="px-2 py-2 text-center text-xs font-semibold text-gray-900 cursor-help border-l-2 border-gray-300" title="Click cells to view bookings">
                                        →
                                    </th>
                                    <th className="px-1 py-2 text-center text-xs font-semibold text-amber-800 bg-amber-50 cursor-help" title="Pending: lease signed but move in not yet booked">
                                        P
                                    </th>
                                    <th className="px-1 py-2 text-center text-xs font-semibold text-gray-500 bg-gray-100 cursor-help" title="Archived: entered Lease Signed and now archived">
                                        A
                                    </th>
                                    <th className="px-2 py-2 text-center text-xs font-semibold text-gray-900 cursor-help border-l-2 border-gray-300" title="Click cells to view bookings">
                                        →
                                    </th>
                                    <th className="px-1 py-2 text-center text-xs font-semibold text-amber-800 bg-amber-50 cursor-help" title="Pending: move in booked but not yet moved in">
                                        P
                                    </th>
                                    <th className="px-1 py-2 text-center text-xs font-semibold text-gray-500 bg-gray-100 cursor-help" title="Archived: entered Move In Booked and now archived">
                                        A
                                    </th>
                                    <th className="px-2 py-2 text-center text-xs font-semibold text-gray-900 bg-green-50 cursor-help border-l-2 border-gray-300" title="Click cells to view bookings">
                                        → In
                                    </th>
                                    <th className="px-2 py-2 text-center text-xs font-semibold text-gray-900 bg-blue-50 border-l-2 border-gray-300">
                                        %
                                    </th>
                                </tr>
                            </thead>
                            <tbody className="divide-y divide-gray-200 bg-white">
                                {reportData.properties.map((property) => (
                                    <tr key={property.property_id} className="hover:bg-gray-50">
                                        <td className="px-2 py-3 text-sm font-medium text-gray-900 sticky left-0 bg-white">
                                            {property.property_name}
                                        </td>
                                        <td 
                                            className="px-2 py-3 text-sm text-center text-gray-700 font-semibold cursor-pointer hover:bg-blue-100"
                                            onClick={() => openBookingsModal(property.property_id, property.property_name, 'total_applications', 'Total Applications')}
                                        >
                                            {property.total_applications}
                                        </td>
                                        <td 
                                            className="px-2 py-3 text-sm text-center text-gray-600 cursor-pointer hover:bg-blue-100 border-l-2 border-gray-300"
                                            onClick={() => openBookingsModal(property.property_id, property.property_name, 'moved_to_documents', 'Moved to Documents')}
                                        >
                                            {property.moved_to_documents}
                                        </td>
                                        <td 
                                            className="px-1 py-3 text-sm text-center text-amber-700 bg-amber-50 cursor-pointer hover:bg-amber-100"
                                            onClick={() => openBookingsModal(property.property_id, property.property_name, 'pending_documents', 'Pending in Documents')}
                                        >
                                            {property.pending_documents || 0}
                                        </td>
                                        <td 
                                            className="px-1 py-3 text-sm text-center text-gray-500 bg-gray-100 cursor-pointer hover:bg-gray-200"
                                            onClick={() => openBookingsModal(property.property_id, property.property_name, 'archived_pending_documents', 'Archived in Documents')}
                                        >
                                            {property.archived_pending_documents || 0}
                                        </td>
                                        <td 
                                            className="px-2 py-3 text-sm text-center text-gray-600 cursor-pointer hover:bg-blue-100 border-l-2 border-gray-300"
                                            onClick={() => openBookingsModal(property.property_id, property.property_name, 'moved_to_vetting', 'Moved to Vetting')}
                                        >
                                            {property.moved_to_vetting}
                                        </td>
                                        <td 
                                            className="px-1 py-3 text-sm text-center text-amber-700 bg-amber-50 cursor-pointer hover:bg-amber-100"
                                            onClick={() => openBookingsModal(property.property_id, property.property_name, 'pending_vetting', 'Pending in Vetting')}
                                        >
                                            {property.pending_vetting || 0}
                                        </td>
                                        <td 
                                            className="px-1 py-3 text-sm text-center text-gray-500 bg-gray-100 cursor-pointer hover:bg-gray-200"
                                            onClick={() => openBookingsModal(property.property_id, property.property_name, 'archived_pending_vetting', 'Archived in Vetting')}
                                        >
                                            {property.archived_pending_vetting || 0}
                                        </td>
                                        <td 
                                            className="px-2 py-3 text-sm text-center text-gray-600 cursor-pointer hover:bg-blue-100 border-l-2 border-gray-300"
                                            onClick={() => openBookingsModal(property.property_id, property.property_name, 'moved_to_approved', 'Moved to Approved')}
                                        >
                                            {property.moved_to_approved}
                                        </td>
                                        <td 
                                            className="px-2 py-3 text-sm text-center text-red-600 font-medium bg-red-50 cursor-pointer hover:bg-red-100"
                                            onClick={() => openBookingsModal(property.property_id, property.property_name, 'declined_vetting', 'Declined in Vetting')}
                                        >
                                            {property.declined_vetting}
                                        </td>
                                        <td 
                                            className="px-2 py-3 text-sm text-center text-gray-600 cursor-pointer hover:bg-blue-100 border-l-2 border-gray-300"
                                            onClick={() => openBookingsModal(property.property_id, property.property_name, 'moved_to_lease_sent', 'Moved to Lease Sent')}
                                        >
                                            {property.moved_to_lease_sent}
                                        </td>
                                        <td 
                                            className="px-1 py-3 text-sm text-center text-amber-700 bg-amber-50 cursor-pointer hover:bg-amber-100"
                                            onClick={() => openBookingsModal(property.property_id, property.property_name, 'pending_lease_sent', 'Pending in Lease Sent')}
                                        >
                                            {property.pending_lease_sent || 0}
                                        </td>
                                        <td 
                                            className="px-1 py-3 text-sm text-center text-gray-500 bg-gray-100 cursor-pointer hover:bg-gray-200"
                                            onClick={() => openBookingsModal(property.property_id, property.property_name, 'archived_pending_lease_sent', 'Archived in Lease Sent')}
                                        >
                                            {property.archived_pending_lease_sent || 0}
                                        </td>
                                        <td 
                                            className="px-2 py-3 text-sm text-center text-gray-600 cursor-pointer hover:bg-blue-100 border-l-2 border-gray-300"
                                            onClick={() => openBookingsModal(property.property_id, property.property_name, 'moved_to_lease_signed', 'Moved to Lease Signed')}
                                        >
                                            {property.moved_to_lease_signed}
                                        </td>
                                        <td 
                                            className="px-1 py-3 text-sm text-center text-amber-700 bg-amber-50 cursor-pointer hover:bg-amber-100"
                                            onClick={() => openBookingsModal(property.property_id, property.property_name, 'pending_lease_signed', 'Pending in Lease Signed')}
                                        >
                                            {property.pending_lease_signed || 0}
                                        </td>
                                        <td 
                                            className="px-1 py-3 text-sm text-center text-gray-500 bg-gray-100 cursor-pointer hover:bg-gray-200"
                                            onClick={() => openBookingsModal(property.property_id, property.property_name, 'archived_pending_lease_signed', 'Archived in Lease Signed')}
                                        >
                                            {property.archived_pending_lease_signed || 0}
                                        </td>
                                        <td 
                                            className="px-2 py-3 text-sm text-center text-gray-600 cursor-pointer hover:bg-blue-100 border-l-2 border-gray-300"
                                            onClick={() => openBookingsModal(property.property_id, property.property_name, 'moved_to_move_in_booked', 'Moved to Move In Booked')}
                                        >
                                            {property.moved_to_move_in_booked}
                                        </td>
                                        <td 
                                            className="px-1 py-3 text-sm text-center text-amber-700 bg-amber-50 cursor-pointer hover:bg-amber-100"
                                            onClick={() => openBookingsModal(property.property_id, property.property_name, 'pending_move_in_booked', 'Pending in Move In Booked')}
                                        >
                                            {property.pending_move_in_booked || 0}
                                        </td>
                                        <td 
                                            className="px-1 py-3 text-sm text-center text-gray-500 bg-gray-100 cursor-pointer hover:bg-gray-200"
                                            onClick={() => openBookingsModal(property.property_id, property.property_name, 'archived_pending_move_in_booked', 'Archived in Move In Booked')}
                                        >
                                            {property.archived_pending_move_in_booked || 0}
                                        </td>
                                        <td 
                                            className="px-2 py-3 text-sm text-center text-green-600 font-semibold bg-green-50 cursor-pointer hover:bg-green-100 border-l-2 border-gray-300"
                                            onClick={() => openBookingsModal(property.property_id, property.property_name, 'moved_to_moved_in', 'Moved In')}
                                        >
                                            {property.moved_to_moved_in}
                                        </td>
                                        <td className="px-2 py-3 text-sm text-center text-blue-600 font-semibold bg-blue-50 border-l-2 border-gray-300">
                                            {property.conversion_rate}%
                                        </td>
                                    </tr>
                                ))}

                                {totals && (
                                    <tr className="bg-gray-100 font-bold border-t-2 border-gray-400">
                                        <td className="px-2 py-3 text-sm text-gray-900 sticky left-0 bg-gray-100">
                                            TOTAL
                                        </td>
                                        <td className="px-2 py-3 text-sm text-center text-gray-900">
                                            {totals.total_applications}
                                        </td>
                                        <td className="px-2 py-3 text-sm text-center text-gray-900 border-l-2 border-gray-300">
                                            {totals.moved_to_documents}
                                        </td>
                                        <td className="px-1 py-3 text-sm text-center text-amber-800 bg-amber-100">
                                            {totals.pending_documents}
                                        </td>
                                        <td className="px-1 py-3 text-sm text-center text-gray-600 bg-gray-200">
                                            {totals.archived_pending_documents}
                                        </td>
                                        <td className="px-2 py-3 text-sm text-center text-gray-900 border-l-2 border-gray-300">
                                            {totals.moved_to_vetting}
                                        </td>
                                        <td className="px-1 py-3 text-sm text-center text-amber-800 bg-amber-100">
                                            {totals.pending_vetting}
                                        </td>
                                        <td className="px-1 py-3 text-sm text-center text-gray-600 bg-gray-200">
                                            {totals.archived_pending_vetting}
                                        </td>
                                        <td className="px-2 py-3 text-sm text-center text-gray-900 border-l-2 border-gray-300">
                                            {totals.moved_to_approved}
                                        </td>
                                        <td className="px-2 py-3 text-sm text-center text-red-700 bg-red-100">
                                            {totals.declined_vetting}
                                        </td>
                                        <td className="px-2 py-3 text-sm text-center text-gray-900 border-l-2 border-gray-300">
                                            {totals.moved_to_lease_sent}
                                        </td>
                                        <td className="px-1 py-3 text-sm text-center text-amber-800 bg-amber-100">
                                            {totals.pending_lease_sent}
                                        </td>
                                        <td className="px-1 py-3 text-sm text-center text-gray-600 bg-gray-200">
                                            {totals.archived_pending_lease_sent}
                                        </td>
                                        <td className="px-2 py-3 text-sm text-center text-gray-900 border-l-2 border-gray-300">
                                            {totals.moved_to_lease_signed}
                                        </td>
                                        <td className="px-1 py-3 text-sm text-center text-amber-800 bg-amber-100">
                                            {totals.pending_lease_signed}
                                        </td>
                                        <td className="px-1 py-3 text-sm text-center text-gray-600 bg-gray-200">
                                            {totals.archived_pending_lease_signed}
                                        </td>
                                        <td className="px-2 py-3 text-sm text-center text-gray-900 border-l-2 border-gray-300">
                                            {totals.moved_to_move_in_booked}
                                        </td>
                                        <td className="px-1 py-3 text-sm text-center text-amber-800 bg-amber-100">
                                            {totals.pending_move_in_booked}
                                        </td>
                                        <td className="px-1 py-3 text-sm text-center text-gray-600 bg-gray-200">
                                            {totals.archived_pending_move_in_booked}
                                        </td>
                                        <td className="px-2 py-3 text-sm text-center text-green-700 bg-green-100 border-l-2 border-gray-300">
                                            {totals.moved_to_moved_in}
                                        </td>
                                        <td className="px-2 py-3 text-sm text-center text-blue-700 bg-blue-100 border-l-2 border-gray-300">
                                            {totals.conversion_rate}%
                                        </td>
                                    </tr>
                                )}
                            </tbody>
                        </table>

                        <div className="mt-6 p-4 bg-blue-50 rounded-lg">
                            <h3 className="text-sm font-semibold text-blue-900 mb-2">How to Read This Report:</h3>
                            <ul className="text-xs text-blue-800 space-y-1">
                                <li>• <strong>Total Apps:</strong> Bookings created in date range (excludes archived, merged, declined)</li>
                                <li>• <strong>→ Columns:</strong> Number of leads that moved INTO each folder during date range</li>
                                <li>• <strong>Pending (amber):</strong> Entered that stage but never moved to the next — these are your cold/stuck leads</li>
                                <li>• <strong>Archived (gray):</strong> Of those who entered this stage, how many are now archived</li>
                                <li>• <strong>Vetting section:</strong> → Vetting | Pending | Archived | → Approved | Declined</li>
                                <li>• <strong>Conversion %:</strong> (Moved In / Total Apps) × 100</li>
                            </ul>
                        </div>
                    </div>
                )}

                {reportData && reportData.properties && reportData.properties.length === 0 && (
                    <div className="mt-8 p-8 bg-gray-50 rounded-lg text-center">
                        <p className="text-gray-600">No data found for the selected date range.</p>
                    </div>
                )}

                {/* Modal for Booking Details */}
                {showModal && (
                    <div className="fixed inset-0 z-50 overflow-y-auto" aria-labelledby="modal-title" role="dialog" aria-modal="true">
                        <div className="flex items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0">
                            <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" aria-hidden="true" onClick={() => setShowModal(false)}></div>

                            <span className="hidden sm:inline-block sm:align-middle sm:h-screen" aria-hidden="true">&#8203;</span>

                            <div className="inline-block align-bottom bg-white rounded-lg text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-6xl sm:w-full">
                                <div className="bg-white px-4 pt-5 pb-4 sm:p-6 sm:pb-4">
                                    <div className="flex justify-between items-center mb-4">
                                        <h3 className="text-lg leading-6 font-medium text-gray-900" id="modal-title">
                                            {modalTitle} ({modalBookings.length} {modalBookings.length === 1 ? 'booking' : 'bookings'})
                                            {modalBookings.length > 0 && (
                                                <span className="ml-2 text-sm font-normal text-gray-600">
                                                    ({modalBookings.filter(b => !b.deleted_at && b.archived !== 1 && !b.merged_into && b.declined !== 1).length} active, {modalBookings.filter(b => b.deleted_at || b.archived === 1 || b.merged_into || b.declined === 1).length} inactive)
                                                </span>
                                            )}
                                        </h3>
                                        <div className="flex gap-2">
                                            <button
                                                type="button"
                                                className="inline-flex justify-center rounded-md border border-transparent shadow-sm px-4 py-2 bg-green-600 text-base font-medium text-white hover:bg-green-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-green-500 sm:text-sm"
                                                onClick={() => exportModalBookings()}
                                            >
                                                Export to Excel
                                            </button>
                                            <button
                                                type="button"
                                                className="inline-flex justify-center rounded-md border border-gray-300 shadow-sm px-4 py-2 bg-white text-base font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary sm:text-sm"
                                                onClick={() => setShowModal(false)}
                                            >
                                                Close
                                            </button>
                                        </div>
                                    </div>

                                    <div className="mt-2">
                                        {modalLoading ? (
                                            <div className="text-center py-8">
                                                <p className="text-gray-500">Loading bookings...</p>
                                            </div>
                                        ) : modalBookings.length > 0 ? (
                                            <div className="overflow-x-auto max-h-[70vh]">
                                                <table className="min-w-full divide-y divide-gray-300">
                                                    <thead className="bg-gray-50 sticky top-0">
                                                        <tr>
                                                            <th className="px-3 py-3.5 text-left text-xs font-semibold text-gray-900">Booking Ref</th>
                                                            <th className="px-3 py-3.5 text-left text-xs font-semibold text-gray-900">Contact</th>
                                                            <th className="px-3 py-3.5 text-left text-xs font-semibold text-gray-900">Property</th>
                                                            <th className="px-3 py-3.5 text-left text-xs font-semibold text-gray-900">Moved By</th>
                                                            <th className="px-3 py-3.5 text-left text-xs font-semibold text-gray-900">Status</th>
                                                            {currentFolder && currentFolder.startsWith('pending_') && (
                                                                <th className="px-3 py-3.5 text-center text-xs font-semibold text-amber-800 bg-amber-50">Days Pending</th>
                                                            )}
                                                            {currentFolder && ['moved_to_vetting', 'pending_vetting', 'declined_vetting'].includes(currentFolder) && (
                                                                <th className="px-3 py-3.5 text-left text-xs font-semibold text-gray-900">TPN Requested By</th>
                                                            )}
                                                            {currentFolder && ['moved_to_move_in_booked', 'pending_move_in_booked'].includes(currentFolder) && (
                                                                <th className="px-3 py-3.5 text-left text-xs font-semibold text-gray-900">Move In Date</th>
                                                            )}
                                                            <th className="px-3 py-3.5 text-left text-xs font-semibold text-gray-900">Journey</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody className="divide-y divide-gray-200 bg-white">
                                                        {modalBookings.map((booking, index) => {
                                                            const isDeleted = booking.deleted_at !== null;
                                                            const isArchived = booking.archived === 1;
                                                            const isMerged = booking.merged_into !== null;
                                                            const isDeclined = booking.declined === 1;
                                                            const isNonClickable = isDeleted || isMerged;
                                                            const isInactive = isDeleted || isArchived || isMerged || isDeclined;
                                                            
                                                            let statusBadge = null;
                                                            let statusColor = 'bg-green-100 text-green-800';
                                                            let bookingUrl = `/booking/all?user_id=${booking.user_id}&booking_id=${booking.booking_id}`;
                                                            
                                                            if (isDeleted) {
                                                                statusBadge = 'Deleted';
                                                                statusColor = 'bg-gray-100 text-gray-800';
                                                            } else if (isArchived) {
                                                                statusBadge = 'Archived';
                                                                statusColor = 'bg-yellow-100 text-yellow-800';
                                                                bookingUrl = `/booking/archived?user_id=${booking.user_id}&booking_id=${booking.booking_id}`;
                                                            } else if (isMerged) {
                                                                statusBadge = 'Merged';
                                                                statusColor = 'bg-purple-100 text-purple-800';
                                                            } else if (isDeclined) {
                                                                statusBadge = 'Declined';
                                                                statusColor = 'bg-red-100 text-red-800';
                                                                bookingUrl = `/booking/declined?user_id=${booking.user_id}&booking_id=${booking.booking_id}`;
                                                            } else {
                                                                statusBadge = 'Active';
                                                            }
                                                            
                                                            return (
                                                                <tr key={index} className={`hover:bg-gray-50 ${isInactive ? 'opacity-60' : ''}`}>
                                                                    <td className="px-3 py-4 text-sm">
                                                                        {isNonClickable ? (
                                                                            <span className="text-gray-500">{booking.booking_reference || 'N/A'}</span>
                                                                        ) : (
                                                                            <a href={bookingUrl} target="_blank" rel="noopener noreferrer" className="text-blue-600 hover:text-blue-800 underline">
                                                                                {booking.booking_reference}
                                                                            </a>
                                                                        )}
                                                                    </td>
                                                                    <td className="px-3 py-2 text-sm">
                                                                        <div className="text-gray-900 font-medium">{booking.name} {booking.surname}</div>
                                                                        <div className="text-gray-500 text-xs">{booking.email}</div>
                                                                        <div className="text-gray-500 text-xs">{booking.cell}</div>
                                                                    </td>
                                                                    <td className="px-3 py-4 text-sm text-gray-600">{booking.property_name || '-'}</td>
                                                                    <td className="px-3 py-4 text-sm text-gray-600">{booking.moved_by || '-'}</td>
                                                                    <td className="px-3 py-4 text-sm">
                                                                        <span className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium ${statusColor}`}>
                                                                            {statusBadge}
                                                                        </span>
                                                                    </td>
                                                                    {currentFolder && currentFolder.startsWith('pending_') && (
                                                                        <td className={`px-3 py-4 text-sm text-center font-semibold ${
                                                                            booking.days_pending >= 14 ? 'text-red-600 bg-red-50' :
                                                                            booking.days_pending >= 7 ? 'text-amber-600 bg-amber-50' :
                                                                            'text-green-600 bg-green-50'
                                                                        }`}>
                                                                            {booking.days_pending != null ? `${booking.days_pending}d` : '-'}
                                                                        </td>
                                                                    )}
                                                                    {currentFolder && ['moved_to_vetting', 'pending_vetting', 'declined_vetting'].includes(currentFolder) && (
                                                                        <td className="px-3 py-4 text-sm text-gray-700">
                                                                            {booking.tpn_requested_by || <span className="text-gray-400">-</span>}
                                                                        </td>
                                                                    )}
                                                                    {currentFolder && ['moved_to_move_in_booked', 'pending_move_in_booked'].includes(currentFolder) && (
                                                                        <td className="px-3 py-4 text-sm text-gray-700">
                                                                            {booking.move_in_date ? new Date(booking.move_in_date).toLocaleDateString('en-ZA', { day: 'numeric', month: 'short', year: 'numeric' }) : <span className="text-gray-400">-</span>}
                                                                        </td>
                                                                    )}
                                                                    <td className="px-3 py-2 text-sm">
                                                                        {booking.journey && booking.journey.length > 0 ? (
                                                                            <div className="flex flex-wrap items-center gap-1">
                                                                                {booking.journey.map((step, i) => {
                                                                                    const stepDate = new Date(step.date);
                                                                                    const dateStr = stepDate.toLocaleDateString('en-ZA', { day: 'numeric', month: 'short', year: 'numeric' }) + ' ' + stepDate.toLocaleTimeString('en-ZA', { hour: '2-digit', minute: '2-digit' });
                                                                                    const isDeclined = step.declined === 1;
                                                                                    const daysBetween = i > 0 ? Math.round((stepDate - new Date(booking.journey[i-1].date)) / (1000 * 60 * 60 * 24)) : null;
                                                                                    const folderStageMap = {
                                                                                        'moved_to_documents': 'Documents', 'pending_documents': 'Documents',
                                                                                        'moved_to_vetting': 'Vetting', 'pending_vetting': 'Vetting',
                                                                                        'moved_to_approved': 'Approved', 'declined_vetting': 'Vetting',
                                                                                        'moved_to_lease_sent': 'Lease Sent', 'pending_lease_sent': 'Lease Sent',
                                                                                        'moved_to_lease_signed': 'Lease Signed', 'pending_lease_signed': 'Lease Signed',
                                                                                        'moved_to_move_in_booked': 'Move In Booked', 'pending_move_in_booked': 'Move In Booked',
                                                                                        'moved_to_moved_in': 'Moved In',
                                                                                    };
                                                                                    const highlightStage = folderStageMap[currentFolder];
                                                                                    const isHighlighted = !isDeclined && highlightStage && (step.to === highlightStage || (highlightStage === 'Approved' && step.to === 'Approval'));
                                                                                    return (
                                                                                        <span key={i} className="inline-flex items-center">
                                                                                            {i > 0 && (
                                                                                                <span className="mx-1 text-gray-400 text-xs">
                                                                                                    →{daysBetween > 0 ? <span className={`ml-0.5 font-semibold ${daysBetween >= 14 ? 'text-red-500' : daysBetween >= 7 ? 'text-amber-500' : 'text-green-500'}`}>{daysBetween}d</span> : ''}
                                                                                                </span>
                                                                                            )}
                                                                                            <span className={`inline-flex items-center px-1.5 py-0.5 rounded text-xs whitespace-nowrap ${
                                                                                                isDeclined ? 'bg-red-100 text-red-700' : isHighlighted ? 'bg-amber-200 text-amber-900 font-semibold ring-1 ring-amber-400' : 'bg-blue-50 text-blue-700'
                                                                                            }`}>
                                                                                                {isDeclined ? '✗ Declined' : step.to}
                                                                                                <span className="ml-1 text-gray-400 text-[10px]">{dateStr}</span>
                                                                                            </span>
                                                                                        </span>
                                                                                    );
                                                                                })}
                                                                                {booking.location && (() => {
                                                                                    const lastStep = booking.journey && booking.journey.length > 0 ? booking.journey[booking.journey.length - 1] : null;
                                                                                    const lastDate = lastStep ? new Date(lastStep.date) : null;
                                                                                    const lastDateStr = lastDate ? lastDate.toLocaleDateString('en-ZA', { day: 'numeric', month: 'short', year: 'numeric' }) + ' ' + lastDate.toLocaleTimeString('en-ZA', { hour: '2-digit', minute: '2-digit' }) : '';
                                                                                    const daysSinceLast = lastDate && booking.journey.length > 0 ? Math.round((new Date() - lastDate) / (1000 * 60 * 60 * 24)) : null;
                                                                                    return (
                                                                                        <span className="inline-flex items-center ml-1">
                                                                                            <span className="mx-1 text-gray-400 text-xs">
                                                                                                →{daysSinceLast > 0 ? <span className={`ml-0.5 font-semibold ${daysSinceLast >= 14 ? 'text-red-500' : daysSinceLast >= 7 ? 'text-amber-500' : 'text-green-500'}`}>{daysSinceLast}d</span> : ''}
                                                                                            </span>
                                                                                            <span className="inline-flex items-center px-1.5 py-0.5 rounded text-xs whitespace-nowrap bg-green-100 text-green-800 font-semibold ring-1 ring-green-300">
                                                                                                📍 {booking.location}
                                                                                                {lastDateStr && <span className="ml-1 text-gray-400 text-[10px]">{lastDateStr}</span>}
                                                                                            </span>
                                                                                        </span>
                                                                                    );
                                                                                })()}
                                                                            </div>
                                                                        ) : (
                                                                            booking.location ? (
                                                                                <span className="inline-flex items-center px-1.5 py-0.5 rounded text-xs whitespace-nowrap bg-green-100 text-green-800 font-semibold ring-1 ring-green-300">
                                                                                    📍 {booking.location}
                                                                                </span>
                                                                            ) : (
                                                                                <span className="text-gray-400">No moves recorded</span>
                                                                            )
                                                                        )}
                                                                    </td>
                                                                </tr>
                                                            );
                                                        })}
                                                    </tbody>
                                                </table>
                                            </div>
                                        ) : (
                                            <div className="text-center py-8">
                                                <p className="text-gray-500">No bookings found.</p>
                                            </div>
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                )}
            </div>
        </>
    );
}
